export const MURAL_IMAGE_ACCEPT = ".avif,.gif,.jpg,.jpeg,.png,.webp";
export const MAX_MURAL_IMAGE_SIZE = 2 * 1024 * 1024;

const allowedImageTypes = new Set([
    "image/avif",
    "image/gif",
    "image/jpeg",
    "image/png",
    "image/webp"
]);

export function isAllowedMuralImage(file) {
    return allowedImageTypes.has(file?.type?.toLowerCase());
}

export function readImageAsDataUrl(file) {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = () => resolve(reader.result);
        reader.onerror = reject;
        reader.readAsDataURL(file);
    });
}
